import '../../../../../styles/globals.css'
import { Box, Modal, Typography } from '@mui/material'
import { Grid } from '@mui/material';

import UsernameIconDisplay from '../UsernameIconDisplay';
import GetYoutubeCode from '../NoteUtils';
import LoveSectionComponent from '../LoveSectionComponent';
import NoteExpiryGridPiece from '../NoteExpiryGridPiece';
import DeleteNoteSectionComponent from '../DeleteNoteSectionComponent';

import { maxWidth } from '@mui/system';
import React from 'react';
import FlashPlayer from '../../../adobeanimate/FlashPlayer';

const ReactMarkdown = require('react-markdown').default;

function FlashNoteComponent(props) {

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <Box>
            <Grid container className='' spacing={0.5} sx={{
                width: "21.55rem",
                justifyContent: "center",
                alignItems: "center",
                padding: "0.5rem",
                margin: "0.25rem",
                backgroundColor: "rgba(221, 221, 221, 0.075)",
                borderRadius: "0.25rem",
                borderColor: "rgba(221, 221, 221, 0.25)",
                border: "1px solid rgba(221, 221, 221, 0.35)"
            }}>
                <Grid item xs={6} sm={6}>
                    <UsernameIconDisplay note={props.note} />
                </Grid>
                <DeleteNoteSectionComponent note={props.note} />
                <LoveSectionComponent note={props.note} />
                <Grid item xs={12} sm={12} sx={{ width: "100%", marginTop: "0.0rem", marginBottom: "0.0rem", justifyContent: "center", alignItems: "center", marginRight: "0.3rem" }}>
                    <Box sx={{
                        margin: 0,
                        padding: 0,
                        marginTop: "0.0rem",
                        borderRadius: "0.25rem",
                        display: "flex",
                        height: "100%",
                        width: "100%",
                        maxWidth: "36rem",
                        justifyContent: "center",
                        alignItems: "center",
                        outline: 'none'
                    }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%', // Full viewport height
                        }}>
                            <FlashPlayer width={'320px'} height={'270px'} swfTarget={props.note.url}/>
                        </div>
                    </Box>
                </Grid>
                <NoteExpiryGridPiece note={props.note} neverExpires={props.neverExpires} />
                <Grid item xs={6} sm={6} sx={{ textAlign: "right", paddingRight: "1rem", padding: "0.5rem" }}>
                </Grid>
            </Grid>
        </Box >
    );
}

export default FlashNoteComponent;